import { Module, VuexModule, Mutation, getModule, Action } from "vuex-module-decorators";
import { commitBusyStart, commitBusyStop, ISettings, ISettingsState, IStoreState, store, ISettingsIp } from "@/loader";
import { VIPSettingsRest } from "@/class/rest/VIPSettingsRest";
import { ActionContext } from "vuex";

@Module({
	name: "settings",
	store,
	dynamic: true,
	namespaced: true,
})
export class SettingsModule extends VuexModule<ISettingsState, IStoreState> implements ISettings {
	public logo_url: string = "";

	public renew_limit: number = 0;

	public customary1_qty: number = 0;
	public customary1_limit: number = 0;
	public customary2_qty: number = 0;
	public customary2_limit: number = 0;
	public customary_duration: number = 0;
	public customary_extension_duration: number = 0;
	public customary_has_extension: boolean = false;

	public probationary1_qty: number = 0;
	public probationary1_limit: number = 0;
	public probationary2_qty: number = 0;
	public probationary2_limit: number = 0;
	public probationary_duration: number = 0;
	public probationary_extension_duration: number = 0;
	public probationary_has_extension: boolean = false;

	public exceptional1_qty: number = 0;
	public exceptional1_limit: number = 0;
	public exceptional2_qty: number = 0;
	public exceptional2_limit: number = 0;
	public exceptional_duration: number = 0;
	public exceptional_extension_duration: number = 0;
	public exceptional_has_extension: boolean = false;

	/** Header Model */
	public model_header: string = "";
	/** Title Model */
	public model_title: string = "";
	/** Price Model */
	public model_price: string = "";
	/** Subcontracting Model */
	public model_subcontracting: string = "";
	/** Conclusion Model */
	public model_conclusion: string = "";
	/** Observations Model */
	public model_observations: string = "";
	/** Specific Materials Model */
	public model_specific_materials: string = "";
	/** Other Means Model */
	public model_other_means: string = "";

	public company_name: string = "";
	public company_address: string = "";
	public company_zipcode: string = "";
	public company_city: string = "";
	public company_tp: string = "";
	public company_status: string = "";
	public company_capital: string = "";
	public company_rcs: string = "";
	public company_siren: string = "";
	public company_ape: string = "";
	public company_phone: string = "";
	public company_fax: string = "";
	public company_url: string = "";
	public company_contact: string = "";
	public company_email: string = "";
	public company_sign: string = "";
	public company_sign_position: string = "";
	public company_employees: number = 0;
	public company_workers: number = 0;
	public company_clericals: number = 0;
	public company_executives: number = 0;
	public company_design_workers: number = 0;
	public company_lab_workers: number = 0;

	public get maxExceptionalLimit(): number {
		return this.exceptional1_limit === 0 || this.exceptional2_limit === 0 ? 0
			: Math.max(this.exceptional1_limit, this.exceptional2_limit);
	}

	public get maxProbationaryLimit(): number {
		return this.probationary1_limit === 0 || this.probationary2_limit === 0 ? 0
			: Math.max(this.probationary1_limit, this.probationary2_limit);
	}

	public get maxCustomaryLimit(): number {
		return this.customary1_limit === 0 || this.customary2_limit === 0 ? 0
			: Math.max(this.customary1_limit, this.customary2_limit);
	}

	@Mutation
	public init() {
		if (window.vip_data && window.vip_data.settings) {
			this.logo_url = String.orDefault(window.vip_data.settings.logo_url);
			this.renew_limit = Number.orDefault(window.vip_data.settings.renew_limit);
			this.customary1_qty = Number.orDefault(window.vip_data.settings.customary1_qty);
			this.customary1_limit = Number.orDefault(window.vip_data.settings.customary1_limit);
			this.customary2_qty = Number.orDefault(window.vip_data.settings.customary2_qty);
			this.customary2_limit = Number.orDefault(window.vip_data.settings.customary2_limit);
			this.customary_duration = Number.orDefault(window.vip_data.settings.customary_duration);
			this.customary_extension_duration = Number.orDefault(window.vip_data.settings.customary_extension_duration);
			this.customary_has_extension = Boolean.orDefault(window.vip_data.settings.customary_has_extension);
			this.probationary1_qty = Number.orDefault(window.vip_data.settings.probationary1_qty);
			this.probationary1_limit = Number.orDefault(window.vip_data.settings.probationary1_limit);
			this.probationary2_qty = Number.orDefault(window.vip_data.settings.probationary2_qty);
			this.probationary2_limit = Number.orDefault(window.vip_data.settings.probationary2_limit);
			this.probationary_duration = Number.orDefault(window.vip_data.settings.probationary_duration);
			this.probationary_extension_duration = Number.orDefault(window.vip_data.settings.probationary_extension_duration);
			this.probationary_has_extension = Boolean.orDefault(window.vip_data.settings.probationary_has_extension);
			this.exceptional1_qty = Number.orDefault(window.vip_data.settings.exceptional1_qty);
			this.exceptional1_limit = Number.orDefault(window.vip_data.settings.exceptional1_limit);
			this.exceptional2_qty = Number.orDefault(window.vip_data.settings.exceptional2_qty);
			this.exceptional2_limit = Number.orDefault(window.vip_data.settings.exceptional2_limit);
			this.exceptional_duration = Number.orDefault(window.vip_data.settings.exceptional_duration);
			this.exceptional_extension_duration = Number.orDefault(window.vip_data.settings.exceptional_extension_duration);
			this.exceptional_has_extension = Boolean.orDefault(window.vip_data.settings.exceptional_has_extension);
			this.model_header = String.orDefault(window.vip_data.settings.model_header);
			this.model_title = String.orDefault(window.vip_data.settings.model_title);
			this.model_price = String.orDefault(window.vip_data.settings.model_price);
			this.model_subcontracting = String.orDefault(window.vip_data.settings.model_subcontracting);
			this.model_conclusion = String.orDefault(window.vip_data.settings.model_conclusion);
			this.model_observations = String.orDefault(window.vip_data.settings.model_observations);
			this.model_specific_materials = String.orDefault(window.vip_data.settings.model_specific_materials);
			this.model_other_means = String.orDefault(window.vip_data.settings.model_other_means);
			this.company_name = String.orDefault(window.vip_data.settings.company_name);
			this.company_address = String.orDefault(window.vip_data.settings.company_address);
			this.company_zipcode = String.orDefault(window.vip_data.settings.company_zipcode);
			this.company_city = String.orDefault(window.vip_data.settings.company_city);
			this.company_tp = String.orDefault(window.vip_data.settings.company_tp);
			this.company_status = String.orDefault(window.vip_data.settings.company_status);
			this.company_capital = String.orDefault(window.vip_data.settings.company_capital);
			this.company_rcs = String.orDefault(window.vip_data.settings.company_rcs);
			this.company_siren = String.orDefault(window.vip_data.settings.company_siren);
			this.company_ape = String.orDefault(window.vip_data.settings.company_ape);
			this.company_phone = String.orDefault(window.vip_data.settings.company_phone);
			this.company_fax = String.orDefault(window.vip_data.settings.company_fax);
			this.company_url = String.orDefault(window.vip_data.settings.company_url);
			this.company_contact = String.orDefault(window.vip_data.settings.company_contact);
			this.company_email = String.orDefault(window.vip_data.settings.company_email);
			this.company_sign = String.orDefault(window.vip_data.settings.company_sign);
			this.company_sign_position = String.orDefault(window.vip_data.settings.company_sign_position);
			this.company_employees = Number.orDefault(window.vip_data.settings.company_employees);
			this.company_workers = Number.orDefault(window.vip_data.settings.company_workers);
			this.company_clericals = Number.orDefault(window.vip_data.settings.company_clericals);
			this.company_executives = Number.orDefault(window.vip_data.settings.company_executives);
			this.company_design_workers = Number.orDefault(window.vip_data.settings.company_design_workers);
			this.company_lab_workers = Number.orDefault(window.vip_data.settings.company_lab_workers);
		}
	}

	@Mutation
	public set(payload: ISettings) {
		if (payload.logo_url !== undefined) {
			this.logo_url = String.orDefault(payload.logo_url);
		}
		if (payload.renew_limit !== undefined) {
			this.renew_limit = Number.orDefault(payload.renew_limit);
		}
		if (payload.customary1_qty !== undefined) {
			this.customary1_qty = Number.orDefault(payload.customary1_qty);
		}
		if (payload.customary1_limit !== undefined) {
			this.customary1_limit = Number.orDefault(payload.customary1_limit);
		}
		if (payload.customary2_qty !== undefined) {
			this.customary2_qty = Number.orDefault(payload.customary2_qty);
		}
		if (payload.customary2_limit !== undefined) {
			this.customary2_limit = Number.orDefault(payload.customary2_limit);
		}
		if (payload.customary_duration !== undefined) {
			this.customary_duration = Number.orDefault(payload.customary_duration);
		}
		if (payload.customary_extension_duration !== undefined) {
			this.customary_extension_duration = Number.orDefault(payload.customary_extension_duration);
		}
		if (payload.customary_has_extension !== undefined) {
			this.customary_has_extension = Boolean.orDefault(payload.customary_has_extension);
		}
		if (payload.probationary1_qty !== undefined) {
			this.probationary1_qty = Number.orDefault(payload.probationary1_qty);
		}
		if (payload.probationary1_limit !== undefined) {
			this.probationary1_limit = Number.orDefault(payload.probationary1_limit);
		}
		if (payload.probationary2_qty !== undefined) {
			this.probationary2_qty = Number.orDefault(payload.probationary2_qty);
		}
		if (payload.probationary2_limit !== undefined) {
			this.probationary2_limit = Number.orDefault(payload.probationary2_limit);
		}
		if (payload.probationary_duration !== undefined) {
			this.probationary_duration = Number.orDefault(payload.probationary_duration);
		}
		if (payload.probationary_extension_duration !== undefined) {
			this.probationary_extension_duration = Number.orDefault(payload.probationary_extension_duration);
		}
		if (payload.probationary_has_extension !== undefined) {
			this.probationary_has_extension = Boolean.orDefault(payload.probationary_has_extension);
		}
		if (payload.exceptional1_qty !== undefined) {
			this.exceptional1_qty = Number.orDefault(payload.exceptional1_qty);
		}
		if (payload.exceptional1_limit !== undefined) {
			this.exceptional1_limit = Number.orDefault(payload.exceptional1_limit);
		}
		if (payload.exceptional2_qty !== undefined) {
			this.exceptional2_qty = Number.orDefault(payload.exceptional2_qty);
		}
		if (payload.exceptional2_limit !== undefined) {
			this.exceptional2_limit = Number.orDefault(payload.exceptional2_limit);
		}
		if (payload.exceptional_duration !== undefined) {
			this.exceptional_duration = Number.orDefault(payload.exceptional_duration);
		}
		if (payload.exceptional_extension_duration !== undefined) {
			this.exceptional_extension_duration = Number.orDefault(payload.exceptional_extension_duration);
		}
		if (payload.exceptional_has_extension !== undefined) {
			this.exceptional_has_extension = Boolean.orDefault(payload.exceptional_has_extension);
		}
		if (payload.model_header !== undefined) {
			this.model_header = String.orDefault(payload.model_header);
		}
		if (payload.model_title !== undefined) {
			this.model_title = String.orDefault(payload.model_title);
		}
		if (payload.model_price !== undefined) {
			this.model_price = String.orDefault(payload.model_price);
		}
		if (payload.model_subcontracting !== undefined) {
			this.model_subcontracting = String.orDefault(payload.model_subcontracting);
		}
		if (payload.model_conclusion !== undefined) {
			this.model_conclusion = String.orDefault(payload.model_conclusion);
		}
		if (payload.model_observations !== undefined) {
			this.model_observations = String.orDefault(payload.model_observations);
		}
		if (payload.model_specific_materials !== undefined) {
			this.model_specific_materials = String.orDefault(payload.model_specific_materials);
		}
		if (payload.model_other_means !== undefined) {
			this.model_other_means = String.orDefault(payload.model_other_means);
		}
		if (payload.company_name !== undefined) {
			this.company_name = String.orDefault(payload.company_name);
		}
		if (payload.company_address !== undefined) {
			this.company_address = String.orDefault(payload.company_address);
		}
		if (payload.company_zipcode !== undefined) {
			this.company_zipcode = String.orDefault(payload.company_zipcode);
		}
		if (payload.company_city !== undefined) {
			this.company_city = String.orDefault(payload.company_city);
		}
		if (payload.company_tp !== undefined) {
			this.company_tp = String.orDefault(payload.company_tp);
		}
		if (payload.company_status !== undefined) {
			this.company_status = String.orDefault(payload.company_status);
		}
		if (payload.company_capital !== undefined) {
			this.company_capital = String.orDefault(payload.company_capital);
		}
		if (payload.company_rcs !== undefined) {
			this.company_rcs = String.orDefault(payload.company_rcs);
		}
		if (payload.company_siren !== undefined) {
			this.company_siren = String.orDefault(payload.company_siren);
		}
		if (payload.company_ape !== undefined) {
			this.company_ape = String.orDefault(payload.company_ape);
		}
		if (payload.company_phone !== undefined) {
			this.company_phone = String.orDefault(payload.company_phone);
		}
		if (payload.company_fax !== undefined) {
			this.company_fax = String.orDefault(payload.company_fax);
		}
		if (payload.company_url !== undefined) {
			this.company_url = String.orDefault(payload.company_url);
		}
		if (payload.company_contact !== undefined) {
			this.company_contact = String.orDefault(payload.company_contact);
		}
		if (payload.company_email !== undefined) {
			this.company_email = String.orDefault(payload.company_email);
		}
		if (payload.company_sign !== undefined) {
			this.company_sign = String.orDefault(payload.company_sign);
		}
		if (payload.company_sign_position !== undefined) {
			this.company_sign_position = String.orDefault(payload.company_sign_position);
		}
		if (payload.company_employees !== undefined) {
			this.company_employees = Number.orDefault(payload.company_employees);
		}
		if (payload.company_workers !== undefined) {
			this.company_workers = Number.orDefault(payload.company_workers);
		}
		if (payload.company_clericals !== undefined) {
			this.company_clericals = Number.orDefault(payload.company_clericals);
		}
		if (payload.company_executives !== undefined) {
			this.company_executives = Number.orDefault(payload.company_executives);
		}
		if (payload.company_design_workers !== undefined) {
			this.company_design_workers = Number.orDefault(payload.company_design_workers);
		}
		if (payload.company_lab_workers !== undefined) {
			this.company_lab_workers = Number.orDefault(payload.company_lab_workers);
		}
	}

	@Action
	public save() {
		commitBusyStart(this.context, "Sauvegarde des options ...");
		let data: ISettings = {...this.context.state};
		VIPSettingsRest.update(data).then(result => {
			if (result.success && result.item) {
				commitSettingsSet(this.context, result.item);
			}
		}).finally(() => {
			commitBusyStop(this.context);
		});
	}
}

export const settings = getModule(SettingsModule, store);

export function commitSettingsSet(context: ActionContext<any, any>, payload: ISettings) {
	context.commit("settings/set", payload, { root: true });
}
